<template>
  <div
    id="addWishlistModal"
    :class="['wish-modal', { show: !loading }]"
    tabindex="-1"
    aria-labelledby="addWishlistLabel"
    role="dialog"
    aria-modal="true"
    @click="closeModal"
  >
    <section @click="stopPropagation($event)">
        <button
          type="button"
          class="btn fs-7"
          aria-label="Close"
          @click="closeModal"
        >
          <span class="icon-close"></span>
        </button>
        <h2 id="addWishlistLabel">Opret ønskeliste</h2>
      <div class="input-wrapper">
        <label for="wishlistName">Ønskelistens navn</label>
        <input id="wishlistName" type="text" placeholder="Min ønskeliste" v-model="wishlistName" />
        <span></span>
      </div>
      <div class="error-info" role="alert" v-if="hasError">
        {{errorMessage}}
      </div>
      <div v-else>Højst 50 tegn</div>
      <div>
        <button type="button" class="btn ps-0" @click="closeModal">Annullér</button>
        <button type="button" class="btn border rounded-pill" @click="saveWishlist">Gem</button>
      </div>
    </section>
  </div>
</template>
<script>
import helpers from '../../plugins/globalHelpers.js';
export default {
  name: "AddWishlistModal",
  data() {
    return {
      loading: true,
      wishlistName: "",
      hasError: false,
      errorMessage: "Ønskelistens navn skal udfyldes"
    }
  },
  mounted() {
    this.init();
    helpers.trapFocus(document.getElementById("addWishlistModal"));
  },
  methods: {
    init: function() {
      document.body.style.paddingRight = "8px";
      document.body.style.overflow = "hidden";
      document.body.classList.add("modal-open");
      setTimeout(() => {
        this.loading = false;
      }, 0);
    },
    closeModal: function() {
      const addToWishlistModal = document.getElementById("favoritesModal");
      if (!addToWishlistModal || !addToWishlistModal.classList.contains("show")) {
        document.body.style.removeProperty("overflow");
        document.body.style.removeProperty("padding-right");
        document.body.classList.remove("modal-open");
      }
      this.loading = true;
      setTimeout(() => {
        this.$parent.closeAddWishlistModal();
      }, 300);
    },
    stopPropagation(event) {
      event.stopPropagation();
    },
    saveWishlist: function() {
      if(this.wishlistName.length && this.wishlistName.length <= 50) {
        this.hasError = false;
        this.$store.dispatch("saveWishlist", this.wishlistName).then((response) => {
          this.$store.dispatch("getWishlists");
          this.closeModal();
        });
      } else if(this.wishlistName.length > 50) {
          this.errorMessage = "Listens navn må højst være 50 tegn";
          this.hasError = true;
      } else {
        this.errorMessage = "Ønskelistens navn skal udfyldes";
        this.hasError = true;
      }
    }
  },
};
</script>